export const ComponentThemeProvider = <T extends React.ReactNode>(
  theme: string,
  Dark: T,
  Default: T,
) => (theme === 'dark' ? Dark : Default)
